const isHourInUse = (hour, start, finish) => {
  if (start > finish) {
    return hour >= start || hour < finish;
  }
  return hour >= start && hour < finish;
};

export default isHourInUse;
